import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	//sso 로그인
	ssoLogin: ({ token, langCd, scrId }) => {
		return new Promise((resolve, reject) => {
			client
				.post(`${BASE_URL}/user/v1/ssoLogin`, null, { params: { token, langCd, scrId } })
				.then(response => resolve(response.data))
				.catch(error => {
					reject(new Error(error.message || error.response));
				});
		});
	},

	//direct 로그인
	directLogin: ({ userId, userPw, langCd, scrId }) => {
		return new Promise((resolve, reject) => {
			client
				.post(`${BASE_URL}/user/v1/directLogin`, null, { params: { userId, userPw, langCd, scrId } })
				.then(response => resolve(response.data))
				.catch(error => {
					reject(new Error(error.message || error.response));
				});
		});
	},

	//사용자 로그인
	login: ({ userId, userPw, otp }) => {
		return new Promise((resolve, reject) => {
			client
				.post(`${BASE_URL}/auth/v1/user/login/process`, null, { params: { userId, userPw, otp } })
				.then(response => resolve(response.data))
				.catch(error => {
					reject(new Error(error.message || error.response));
				});
		});
	},

	//사용자 언어 변경
	updateLangCd: ({ plantCd, langCd }) => {
		return new Promise((resolve, reject) => {
			client
				.post(`${BASE_URL}/user/v1/status/2/plants/${plantCd}/langCd/${langCd}`)
				.then(response => resolve(response.data))
				.catch(error => {
					reject(new Error(error.message || error.response));
				});
		});
	},

	//사용자 색상 테마 변경
	updateTopSkin: ({ plantCd, topSkin }) => {
		return new Promise((resolve, reject) => {
			client
				.post(`${BASE_URL}/user/v1/status/2/plants/${plantCd}/topSkin/${topSkin}`)
				.then(response => resolve(response.data))
				.catch(error => {
					reject(new Error(error.message || error.response));
				});
		});
	},

	//사용자 폰트 테마 변경
	updateFont: ({ plantCd, font }) => {
		return new Promise((resolve, reject) => {
			client
				.post(`${BASE_URL}/user/v1/status/2/plants/${plantCd}/font/${font}`)
				.then(response => resolve(response.data))
				.catch(error => {
					reject(new Error(error.message || error.response));
				});
		});
	},

	//langCd를 이용한 다국어 리스트 조회(로그인 페이지 용)
	getLangMessage: ({ langCd }) => {
		return new Promise((resolve, reject) => {
			client
				.get(`${BASE_URL}/message/v1/languages/${langCd}`)
				.then(response => resolve(response.data))
				.catch(error => {
					reject(new Error(error.message || error.response));
				});
		});
	},

	//사용자에 등록된 다국어 리스트 조회
	getUserMessage: () => {
		return new Promise((resolve, reject) => {
			client
				.get(`${BASE_URL}/cc/v1/messages`)
				.then(response => resolve(response.data))
				.catch(error => {
					reject(new Error(error.message || error.response));
				});
		});
	},

	//onsite 화면 정보 조회
	getScreen: ({ plantCd, scrId }) => {
		return new Promise((resolve, reject) => {
			client
				.get(`${BASE_URL}/menu/v1/plants/${plantCd}/screens/${scrId}`)
				.then(response => resolve(response.data))
				.catch(error => {
					reject(new Error(error.message || error.response));
				});
		});
	},

	//즐겨찾기 목록 조회
	getFavorite: ({ plantCd }) => {
		return new Promise((resolve, reject) => {
			client
				.get(`${BASE_URL}/menu/v1/plants/${plantCd}/favorites`)
				.then(response => resolve(response.data))
				.catch(error => {
					reject(new Error(error.message || error.response));
				});
		});
	},

	//즐겨찾기 등록
	setFavorite: ({ plantCd, scrId }) => {
		return new Promise((resolve, reject) => {
			return client
				.post(`${BASE_URL}/menu/v1/status/1/plants/${plantCd}/favorites/${scrId}`)
				.then(response => resolve(response.data))
				.catch(error => {
					reject(new Error(error.message || error.response));
				});
		});
	},

	//즐겨찾기 삭제
	deleteFavorite: ({ plantCd, scrId }) => {
		return new Promise((resolve, reject) => {
			client
				.post(`${BASE_URL}/menu/v1/status/3/plants/${plantCd}/favorites/${scrId}`)
				.then(response => resolve(response.data))
				.catch(error => {
					reject(new Error(error.message || error.response));
				});
		});
	},

	//로그아웃
	logout: () => {
		return new Promise((resolve, reject) => {
			client
				.post(`${BASE_URL}/user/v1/logout`)
				.then(response => resolve(response.data))
				.catch(error => {
					reject(new Error(error.message || error.response));
				});
		});
	},

	//제어권 반납
	userLockReturn: ({ scrId }) => {
		return new Promise((resolve, reject) => {
			client
				.post(`${BASE_URL}/user/v1/status/2/userLock/screens/${scrId}`)
				.then(response => resolve(response.data))
				.catch(error => {
					reject(new Error(error.message || error.response));
				});
		});
	},

	// 비밀번호 초기화
	passwordInit: ({ userId, email }) => {
		return new Promise((resolve, reject) => {
			client
				.post(`${BASE_URL}/user/v1/password/init`, { userId, email })
				.then(response => resolve(response.data))
				.catch(error => {
					reject(new Error(error.message || error.response));
				});
		});
	},

	// 비밀번호 재설정
	passwordUpdate: ({ userId, userPwd, newUserPwd }) => {
		return new Promise((resolve, reject) => {
			client
				.post(`${BASE_URL}/user/v1/password/update`, { userId, userPwd, newUserPwd })
				.then(response => resolve(response.data))
				.catch(error => {
					reject(new Error(error.message || error.response));
				});
		});
	},
	//그룹웨어 연동 sso Login
	GwSsoLogin: () => {
		return new Promise((resolve, reject) => {
			client
				.get(`${BASE_URL}/user/v1/sessionUser`, null)
				.then(response => resolve(response.data))
				.catch(error => {
					reject(new Error(error.message || error.response));
				});
		});
	}

};
